import React, { useState } from 'react';
import { Security, VpnKey } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Button,
  MenuItem
} from '@mui/material';
import {
  Dashboard,
  People,
  Pets,
  LocalHospital,
  Logout,
  Settings
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

const menuItems = user?.role === 'Super Admin' ? [
  { label: 'Dashboard', icon: <Dashboard />, path: '/super-admin' },
  { label: 'Utilisateurs', icon: <People />, path: '/super-admin/users' },
  { label: 'Permissions', icon: <Security />, path: '/super-admin/permissions' },
  { label: 'Licences', icon: <VpnKey />, path: '/super-admin/licences' }
] : [
  { label: 'Accueil', icon: <Dashboard />, path: '/dashboard' },
  { label: 'Clients', icon: <People />, path: '/clients' },
  { label: 'Animaux', icon: <Pets />, path: '/animaux' },
  { label: 'Consultations', icon: <LocalHospital />, path: '/consultations' },
  ...(user?.role === 'Vétérinaire' ? [
    { label: 'Utilisateurs', icon: <People />, path: '/users' }
  ] : [])
];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              <img src="/veto-logo2.png" alt="Véto Logo" style={{ width: '50px', height: '50px', marginRight: '12px' }} />
          </Typography>

          {menuItems.map((item) => (
            <Button
              key={item.path}
              color="inherit"
              startIcon={item.icon}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </Button>
          ))}

          <IconButton
            size="large"
            onClick={handleMenu}
            color="inherit"
          >
          <Settings sx={{ color: 'white' }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem disabled>
              {user?.prenom} {user?.nom}
            </MenuItem>
            <MenuItem disabled>{user?.role}</MenuItem>
            <MenuItem onClick={handleLogout}>
              <Logout sx={{ mr: 1 }} /> Déconnexion
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Container component="main" sx={{ flexGrow: 1, py: 3 }}>
        {children}
      </Container>

      <Box component="footer" sx={{ py: 2, textAlign: 'center', bgcolor: 'background.paper' }}>
        <Typography variant="body2" color="text.secondary">
         Bienvenue sur Véto-Lik©, votre outil pour une gestion simplifiée et pour le bien-être animal
        </Typography>
      </Box>
    </Box>
  );
};

export default Layout;